import { toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';

export const StyledCardTiles = styled.div<{ variation: string }>`
  @media ${baseVariables.mediaQuery.xl} {
    display: ${props => (props.variation === 'combo' ? 'flex' : 'block')};
  }
  .aem-container:first-child {
    margin-left: 0;
  }
  .carousal_header {
    display: flex;
    flex-direction: ${props => (props.variation === 'combo' ? 'column' : ' row')};
    justify-content: ${props => (props.variation === 'combo' ? 'center' : ' space-between')};
    align-items: ${props => (props.variation === 'combo' ? 'flex-start' : ' unset')};
    width: auto;
    @media ${baseVariables.mediaQuery.md} {
      display: block;
      text-align: center;
      margin-left: 0px;
      width: ${props => (props.variation === 'combo' ? 'auto' : 'auto')};
    }
    @media ${baseVariables.mediaQuery.xl} {
      display: block;
      text-align: center;
      margin-left: 0px;
    }

    .carousal_header--cta {
      display: flex;
      align-items: ${props => (props.variation === 'combo' ? 'unset' : ' flex-end')};
      text-wrap: nowrap;
    }
  }
  .tiles {
    &__track {
      padding-top: ${toRem(24)};
      .glide__slides_authoring {
        width: 100% !important;
        flex-wrap: wrap;
      }
      .tiles__slides {
        .aem-container {
          padding: 0;
        }
      }
    }
    &__track__pt3 {
      overflow: hidden;
      padding-top: ${toRem(8)};
      .tiles__slides_authoring {
        width: 100% !important;
        flex-wrap: wrap;
      }
      .tiles__slides {
        .aem-container {
          padding: 0;
        }
      }
    }
    .card_tiles_container {
      display: grid;
      flex-wrap: wrap;
      list-style: none;
      padding: 0;
      margin: 0;
      grid-template-columns: repeat(2, 1fr);
      @media (max-width: 767px) {
        display: flex;
      }
    }
    .card_tiles_list:nth-child(odd) {
      @media (max-width: 767px) {
        margin-left: 0px;
        margin-right: 0px;
      }
      margin-right: 12px;
      margin-bottom: 24px;
    }
    .card_tiles_list:nth-child(even) {
      @media (max-width: 767px) {
        margin-left: 0px;
        margin-right: 0px;
      }
      margin-left: 12px;
      margin-bottom: 24px;
    }
    .card_tiles_list {
      box-sizing: border-box;
    }
    .center-align {
      display: flex;
      justify-content: center;
      align-items: center;
      .carouselControlType1 {
        .right-arrow {
          right: -1rem;
          @media ${baseVariables.mediaQuery.sm} {
            right: -1.25rem;
          }
        }
        .left-arrow {
          left: -1rem;
          @media ${baseVariables.mediaQuery.sm} {
            left: -1.25rem;
          }
        }
      }
    }
  }
  .tiles--swipeable {
    cursor: default;
  }
`;
